export * from './contentstackAngular2.module';





// WEBPACK FOOTER //
// ./src/app/contentstack/index.ts